export const LocalStorageKeys = {
  LOGGED_IN: 'loggedIn',
  NOTIFICATIONS_TOKEN_ID: 'notifications-token-id',
  HAS_SEEN_AUTO_PUBLISH: 'has-seen-auto-publish',
  LAST_NOTIFICATIONS_PERMISSION_ALERT_DATE: 'last-notifications-permission-alert-date',
};
